





































import {Component, Vue, Watch} from "vue-property-decorator";
import debounce from "lodash/debounce";
import {StockParams} from "@/modules/warehouses/params";
import {WarehouseStore} from "@/modules/warehouses/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import {LadingStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {allBillLadingInWarehouse} from "@/modules/warehouses/services";
import {LadingType} from "@/enums/type";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import StockExcel from "@/modules/warehouses/Stock/components/Excel.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "StockSearch",
    components: {StockExcel, AInputBarCode, EnumSelector, ProvinceSelector, MillisecondDatePicker}
})
export default class extends Vue {
    LadingStatus = LadingStatus;
    LadingType = LadingType;
    ladingCode = "";
    form = new StockParams();
    isExporting = false;
    warehouseExcels = [] as any;
    limitStatus = [
        LadingStatus.NhapKhoChoCapNhat,
        LadingStatus.NhapKhoGiaoHang,
        LadingStatus.NhapKhoChuyenVung,
        LadingStatus.DonSuCo,
        LadingStatus.DuyetHoan,
        LadingStatus.NhapKhoChuyenHoan,
        LadingStatus.PhatLai,
        LadingStatus.DuyetChuyenTiep
    ];

    @Watch('form', {immediate: true, deep: true})
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        WarehouseStore.updateWarehouseParams(val);
        WarehouseStore.stock({...val, page: 1});
    }, 500);

    async exportExcel() {
        try {
            await this.getAllDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-stock"), {
                    name: `Danh sách vận đơn trong kho.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getAllDataExport() {
        try {
            this.isExporting = true;
            const {data} = await allBillLadingInWarehouse();
            this.warehouseExcels = data.datas;
        } catch (e) {
        } finally {
            this.isExporting = false;
        }
    }

    onEnterLadingCode(evt: any) {
        this.$set(this.form, 'ladingCode', evt.target.value || undefined);
    }

}
